export const locale = {
    lang: "en",
    data: {
        NAV: {
            CADASTROS_SUPER_ADMIN: "Super Admin",
            USERS: "Users",
            BULK_COURSE_SUBSCRIPTION: "Bulk Subscriptions",
            ADMINS: "Admins",
            APP: "Back to the APP",
            SUBSCRIPTIONS: "Subscriptions",
            DOWNLOADS: "Downloads",
            CERTIFICATES: "Certificates",
            SUBPLATFORM: "Sub Platform",
            CALENDARS: "Calendars",
            SUBSCRIPTIONTYPES: "Subscription Types",
            SUBSCRIPTION_DATA: "Data",
            SUPPORT_CONTACTS: "Support Contacts",
            SUBSCRIPTION_THEME: "Theme",
            SUBSCRIPTION_USER_FIELDS: "Additional Data (Users)",
            SUBSCRIPTION_FOOTER: "Signature Footer",
            UPLOAD_FILE: "Importação de dados",
            SUBSCRIPTION_LOGIN_SETTINGS: "Login Screen",
            SUBSCRIPTION_COURSES_CATALOG: "Courses Catalog",
            SUBSCRIPTION_COURSES_CATALOG_OLD: "Courses Catalog (Old)",
            SUBSCRIPTION_CERTIFICATION: "Certificate",
            HOST_CONFIG: "Host",
            SUBSCRIPTION_CONTRACT: "Contract",
            SUBSCRIPTION_PRIVACY_POLICY: "Privacy Policy",
            SUBSCRIPTION_TEMRS_OF_USE: "Terms of Use",
            SUBSCRIPTION_TERMS_OF_PURCHASE: "Terms of Purchase",
            PLATFORM_CUSTOMIZATION: "Platform Customization",
            POLICIES_TERMS: "Policies and Terms",
            COMPANY_INFORMATION: "Company Information",
            COURSES: "Courses (Enrolled)",
            PLANS: "Plans",
            HOME: "Home",
            CONFIGURACOES: "Settings",
            TROCASENHA: "Change Password",
            DATA: "Data",
            ANALYTICS: "Analytics",
            BILLS: "Invoices",
            GROUPS: "Groups",
            CATEGORIES: "Categories",
            TEMPLATES: "Templates",
            DOCS: "Documentation",
            LEARNING_PATH: "Learning Paths",
            ACHIEVEMENTS: "Achievements",
            CHECKOUT: "Checkout",
            BILLING_ACCOUNTS: "Accounts",
            EAD: "EAD",
            CADASTROS: "Records",
            PAYMENTS: "Payments",
            CONFIGURATIONS: "Settings",
            AFFILIATES: "Affiliates",
            SPLITRULE: "Payment Split",
            COUPONS: "Coupons",
            COUPONS_SALES_HISTORY: "Sales History",
            IUGU: {
                REPORT: "Report"
            },
            DATA_ANALYSIS_SETTINGS: "Analytics Tools",
            FISCAL: "Fiscal",
            INVOICE_GATEWAYS: "Gateways",
            INVOICE_REPORT: "Invoices",
            WEBHOOKS_CONFIGS: "Settings",
            WEBHOOKS_EVENTS: "Events",
            STORAGE: {
                TITLE: "Library",
                REPORT: "Usage Report"
            },
            GAMIFICATION: {
                TITLE: "Gamification",
                GAMIFICATION_CONFIGS: "Settings",
                ACHIEVEMENTS: "Achievements",
                RANKINGS: "Rankings",
                LEADERBOARDS: "Leaderboards",
                REPORT: "Report",
                DETAILS: "Scores"
            },
            RelatorioGraficos: "Reports & Charts"
        }
    }
};
